module.exports = __webpack_public_path__ + "static/media/home-red.aba1c5a0.png";